<app-top-menu></app-top-menu>

<div>
    <div>
        <div class="container p-4">

            <h1 class="mb-4 mt-4 text-center fw-bolder">ABOUT (TCC)!</h1>
            <div class="d-flex justify-content-center mb-4">
                <hr style="width: 100px;margin-top: -10px;border-width: 3px;color: #dea500" />
            </div>

            <div class="p-4 rounded-3" style="box-shadow: rgba(0, 0, 0, 0.1) 0 5px 15px;">
                <b>
                    Tax Clearance Certificate (TCC) is an official document issued to tax paying individuals or entities to certify payment of all due taxes as at the date of issuance. According to Section 85 (1) of Personal Income Tax Act (PITA) , TCC is issued to a tax paying entity or individual within two weeks of demand after being duly assessed and confirmed that all due taxes has been paid in full for the past three years. Thus, a Tax Clearance Certificate , in respect of the last three years of assessment , discloses a taxpayer’s chargeable income , tax payable , tax paid, and a statement which justifies that no tax is due as at the date of issuance .
                    <br />
                    Tax Clearance Certificate is issued to companies and individuals by the Federal Inland Revenue Service (FIRS) and State Internal Revenue Service (SIRS) respectively. The certificate also serves of high importance as it is required for official purposes which include but are not limited to these:
                    <br />
                </b>

                <br />

                <ol>
                    <li>Application for government loan for industry or business.</li>
                    <li>Registration of motor vehicle.</li>
                    <li>Application for firearms licence.</li>
                    <li>Application for certificate of occupancy.</li>
                    <li>Application for award of contracts by Government, its agencies and registered companies.</li>
                    <li>Application for approval of building plans.</li>
                    <li>Application for trade licence.</li>
                </ol>

                <br />
                <b>
                    Tax Clearance Certificate is filed and issued annually. Tax compliant individuals are required to file or apply for TCC by visiting the Internal Revenue Service of their state of resident with documents showing evidence of payment of their Personal Income Tax and other payments as required by the law and the State Internal Revenue Service (the “Service”). Usually, evidence of payment presented to the Service should cover for the last three years. The certificate is issued by the States Chairman of Internal Revenue Service, or any officer appointed by the Chairman.
                </b>
                <br />
                <br />
                <i>
                    Follow the steps below to apply for the Anambra State Tax Clearance Certificate:
                </i>
                <br /> <br />

                <ol>
                    <li>Login to your user dashboard</li>
                    <li>Click on e-TCC (Electronic Tax Clearance Certificate)</li>
                    <li>Select Year</li>
                    <li>Fill the form and provide the requested documents</li>
                    <li>Verify all receipts</li>
                    <li>Click on the submit button</li>
                </ol>

                <br />
                Upon approval by the Chairman of the Internal Revenue Service, you will receive an email asking you to login to your dashboard and download your eTCC.

                <br /><br />

                <div class="d-flex justify-content-end">
                    <button class="apply-now">
                        APPLY NOW
                    </button>
                </div>
            </div>

        </div>
    </div>
</div>

<!--<app-faq></app-faq>-->

<!--<app-partner></app-partner>-->

<!--<app-getInTouch></app-getInTouch>-->

<app-footer></app-footer>
